import { WORKOUT_KEY } from '../../../../../modules/workout/model/constants/key'
import updateWorkoutAction from '../update'
import WORKOUTS_ACTION from '../../constants/action'

function updatePlanIdWorkoutAction (params) {
  return updateWorkoutAction({
    type: WORKOUTS_ACTION.UPDATE_PLAN_ID,
    payload: {
      key: WORKOUT_KEY.PLAN_ID,
      workout: params.workout,
      value: params.value
    }
  })
}

export default updatePlanIdWorkoutAction
